import axios from "axios";
import { localTimeToUtc } from "common/timeConversions";
import { withoutDefaultParams } from "constants/constants";

// MOSTLY SUPERADMIN & NON-AUTH LAYOUT APIS
const excludedApis = [
  "/admin_login/resend_otp",
  "/admin_login/otp_verification",
  "/admin_login/login",
  "/admin_login/forgot_password",
  "/admin_login/reset_password",
  "/admin_portal/login_manager_account",
  "/admin_portal/get_manager_data",
  "/login/add_admin",
  "/login/add_manager",
  "/edit_get_manager_account_data",
  "/login/edit_get_workspace_data",
  "/login/update_workspace_data",
  "/login/update_manager_account",
  "/login/delete_admin",
  "/login/delete_manager_account",
  "/admin_portal/update_manager_location",
  "/staff_api/profile",
  "/notice_board/notice_board_login",
  "/notice_board/get_notice_board_data",
  "/notice_board/check_notice_board_status",
  "/login/deactivate_manager_account",
];

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_APIBASE,
  auth: {
    username: process.env.REACT_APP_AUTH_USERNAME,
    password: process.env.REACT_APP_AUTH_PASSWORD,
  },
});

const urlWithParams = (path, params) => {
  const sections = path.split(":");
  const sectionsWithParams = sections.map(section => (_.startsWith(section, "/") ? section : params[section]));
  const pathWithParams = sectionsWithParams.join("");
  console.log(pathWithParams);
  return pathWithParams;
};

axiosApi.interceptors.request.use(config => {
  try {
    // return if default params in not required
    if (config.data?.[withoutDefaultParams]) {
      delete config.data?.[withoutDefaultParams];
      return config;
    } else if (config.method !== "get") {
      // return if excluded api call
      if (excludedApis.includes(config.url)) return config;
      // adding default args in JSON & FORMDATA payload
      if (typeof config.data === "string" || config.data instanceof String) {
        const values = JSON.parse(config.data);
        values.current_date = localTimeToUtc() || "";
      } else if (config.data instanceof FormData && typeof config.data !== "string") {
        config.data.append("current_date", localTimeToUtc() || "");
      } else {
        config.data.current_date = localTimeToUtc() || "";
      }
    }
    return config;
  } catch (err) {
    // console.log(config, config.method, typeof config.data, err);
    return config;
  }
});

export async function get(url, data, withHeader = true, headers = {}) {
  return await axiosApi
    .get(url, {
      params: data,
      ...(withHeader && {
        headers: {
          user_token: JSON.parse(localStorage.getItem("authUser"))?.user_token
            ? JSON.parse(localStorage.getItem("authUser"))?.user_token
            : localStorage.getItem("uid")
            ? JSON.parse(localStorage.getItem("uid"))
            : "",
          ...headers,
        },
      }),
    })
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      // console.log(err)
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = "Bad request";
            break;
        }
      }
      throw message;
    });
}

export async function post(url, data, withHeader = true, headers = {}) {
  return await axiosApi
    .post(url, data, {
      ...(withHeader && {
        headers: {
          user_token: JSON.parse(localStorage.getItem("authUser"))?.user_token
            ? JSON.parse(localStorage.getItem("authUser"))?.user_token
            : localStorage.getItem("uid")
            ? JSON.parse(localStorage.getItem("uid"))
            : "",
          ...headers,
        },
      }),
    })
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      console.log(err);
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Unauthorized";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
}

export async function put(url, data, config = {}) {
  return axiosApi.put(url, { ...data }, { ...config }).then(response => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi.delete(url, { ...config }).then(response => response.data);
}
